"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SocialSharing_1 = require("../../components/SocialSharing");
var _globals_1 = require("../_globals");
new SocialSharing_1.SocialSharing(_globals_1.root, {
    hashTag: "#BNR #blijfscherp",
    source: "BNR.nl",
    siteUrl: 'https://www.bnr.nl'
});
